import { type Component } from 'solid-js';
import Projection from '~/features/projection';
import Inputs from '~/features/inputs';

// Forecast plus the assumptions driving it. The rail stays on this page rather
// than in the shell: every control in it is an input to the year table beside
// it, and reading the two apart is how you end up trusting a number that a
// toggle three pages away produced.
//
// Assumptions first. They are the inputs and the table is the output, so
// left-to-right is the order you actually work in.
const FuturePage: Component = () => (
    <>
        <div class='w-60 shrink-0'>
            <Inputs />
        </div>
        <div class='flex-1 min-w-0'>
            <Projection />
        </div>
    </>
);

export default FuturePage;
